import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { NgbDateFRParserFormatter } from './ngb-date-fr-parser-formatter';
import { NgbDateParserFormatter, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date';
import { Subscription } from 'rxjs';
import { ReactiveFormService } from '../../services/reactive-form.service';

@Component({
    selector: 'kt-input-datepicker',
    templateUrl: './datepicker.component.html',
    styleUrls: ['./datepicker.component.scss'],
    providers: [{ provide: NgbDateParserFormatter, useClass: NgbDateFRParserFormatter }]
})
export class DatepickerComponent implements OnInit, OnChanges, OnDestroy {
    @Input() fieldObj: any;
    @Input() options;
    @Input() values;

    @Input() form: FormGroup;
    @Output() valueChange = new EventEmitter<any>();
    isHideExpression = false;
    subscriptions: Subscription[] = [];

    constructor(public config: NgbDatepickerConfig, public formService: ReactiveFormService) { }

    ngOnInit() {
        this.setValidations();
        this.hideExpression();

        const date: any = this.parse(this.fieldObj.value);
        this.form.get(this.fieldObj.key).setValue(date);

        if (this.fieldObj && this.fieldObj.minDate) { this.config.minDate = this.parse(this.fieldObj.minDate); }
        if (this.fieldObj && this.fieldObj.maxDate) { this.config.maxDate = this.parse(this.fieldObj.maxDate); }
        this.config.outsideDays = 'hidden';

    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes && changes.values && changes.values.currentValue) {
            const date: any = this.parse(changes.values.currentValue);
            this.form.get(this.fieldObj.key).setValue(date);
        }
    }

    notifyChange() {
        if (this.form && this.fieldObj.key && this.form.controls[this.fieldObj.key].value) {
            this.valueChange.emit({ key: this.fieldObj.key, value: this.transform(this.form.controls[this.fieldObj.key].value) });
        }
    }

    hideExpression() {

        if (this.fieldObj && this.fieldObj.hideExpression && this.fieldObj.hideExpression.fieldName) {
            this.clearValidations();
            this.subscriptions.push(this.form.controls[this.fieldObj.hideExpression.fieldName].valueChanges.subscribe(val => {
                if (this.fieldObj.hideExpression.fieldValue === this.formService.matchValueExpression(val)) {
                    this.isHideExpression = false;
                    this.setValidations();
                } else {
                    this.clearValidations();
                }
            }));
        }
    }

    setValidations() {
        this.form.controls[this.fieldObj.key].validator =
            Validators.compose([this.fieldObj.required ? Validators.required : null]);
    }

    clearValidations() {
        this.isHideExpression = true;
        this.form.controls[this.fieldObj.key].clearValidators();
        this.form.controls[this.fieldObj.key].updateValueAndValidity();
        this.form.controls[this.fieldObj.key].setValue('');
    }

    ngOnDestroy() {
        this.subscriptions.forEach(sub => sub.unsubscribe());
    }

    transform(value: NgbDate): Date {
        return new Date(value.year, value.month, value.day);
    }

    parse(date) {
        let returnDate = null;
        if (date) {
            const day = date.getDate();
            const month = date.getMonth() + 1;
            const year = date.getFullYear();
            returnDate = { year, month, day };
        }
        return returnDate;
    }

}
